/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_updateCourseRequest } from '../models/api_updateCourseRequest';
import type { db_GetCourseBeneficiaryRow } from '../models/db_GetCourseBeneficiaryRow';
import type { db_GetCourseRow } from '../models/db_GetCourseRow';
import type { db_ListCoursesRow } from '../models/db_ListCoursesRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Courses {
    /**
     * Get a list of courses
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListCoursesRow OK
     * @throws ApiError
     */
    public static listCourses(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListCoursesRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/courses',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a course
     * @param id Course ID
     * @returns db_GetCourseRow OK
     * @throws ApiError
     */
    public static getCourse(
        id: number,
    ): CancelablePromise<db_GetCourseRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/courses/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a course
     * @param id Course ID
     * @param body Course details
     * @returns void
     * @throws ApiError
     */
    public static updateCourse(
        id: number,
        body: api_updateCourseRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/courses/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a course beneficiary
     * @param id Course ID
     * @returns db_GetCourseBeneficiaryRow OK
     * @throws ApiError
     */
    public static getCourseBeneficiary(
        id: number,
    ): CancelablePromise<db_GetCourseBeneficiaryRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/courses/{id}/beneficiary',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
